import React, { useContext, useEffect, useReducer, useState } from "react";
import { InputGroup } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import LoadingBox from "../components/LoadingBox";
import { default as config } from "../config.json";
import useAxios from "../hooks/useAxios";
import { Store } from "../Store";
import "../TableTypeSeed.css";

const reducer = (state, action) => {
  switch (action.type) {
    case "CREATE_REQUEST":
      return { ...state, loading: true };
    case "CREATE_SUCCESS":
      return { ...state, loading: false };
    case "CREATE_FAIL":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default function TableTypeSeed() {
  const [samples, setSamples] = useState([]);
  const [selectedSamples, setSelectedSamples] = useState([]);
  const [samplesAlreadyInUse, setSamplesAlreadyInUse] = useState([]);

  const { state } = useContext(Store);
  const { tableTypes: storeTableTypes } = state;

  const axios = useAxios();
  const [{ loading }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  useEffect(() => {
    setSamplesAlreadyInUse(
      storeTableTypes.filter((s) => s.status).map((s) => s.sample)
    );
  }, [storeTableTypes]);

  useEffect(() => {
    async function fetchSamples() {
      try {
        const { data } = await axios.get("/api/sampletabletypes");
        setSamples(data);
      } catch (error) {
        console.error("Error fetching samples:", error);
      }
    }
    fetchSamples();
  }, []);

  const handleSampleClick = (sampleId) => {
    setSelectedSamples((prevSelected) => {
      if (prevSelected.includes(sampleId)) {
        return prevSelected.filter((id) => id !== sampleId);
      } else {
        return [...prevSelected, sampleId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedSamples.length > 0) {
      setSelectedSamples([]);
    } else {
      const allSampleIds = samples
        .filter((ss) => ss.status)
        .filter((ss) => !samplesAlreadyInUse.includes(ss._id))
        .map((sample) => sample._id);
      setSelectedSamples(allSampleIds);
    }
  };

  const handleAktar = async () => {
    try {
      dispatch({ type: "CREATE_REQUEST" });
      await axios.post("/api/tabletypes/migrate", {
        tableTypes: samples.filter((s) => selectedSamples.includes(s._id)),
      });
      toast.success(
        `${selectedSamples.length} tablo türü başarılı bir şekilde sisteme aktarıldı!`
      );
      dispatch({ type: "CREATE_SUCCESS" });
      setSelectedSamples([]);
    } catch (error) {
      dispatch({ type: "CREATE_FAIL", error });
      toast.error("Hata, tablo türleri aktarılamadı!", error);
    }
  };

  return (
    <div className="sample-table-grid-container">
      {
        <>
          <div className="action-buttons">
            <InputGroup>
              {samples
                .filter((tt) => tt.status)
                .filter((ss) => !samplesAlreadyInUse.includes(ss._id)).length >
                0 && (
                <button
                  onClick={handleSelectAll}
                  className={
                    selectedSamples.length > 0
                      ? "btn btn-danger"
                      : "btn btn-success"
                  }
                >
                  {selectedSamples.length > 0 ? (
                    <FaTimes style={{ marginRight: "8px" }} />
                  ) : (
                    <FaCheck style={{ marginRight: "8px" }} />
                  )}
                  {selectedSamples.length > 0
                    ? `${selectedSamples.length} masa türünü temizle`
                    : `${
                        samples
                          .filter((tt) => tt.status)
                          .filter((ss) => !samplesAlreadyInUse.includes(ss._id))
                          .length
                      } masa türünü seç`}
                </button>
              )}
              {selectedSamples.length > 0 && !loading && (
                <button onClick={handleAktar} className="btn btn-primary">
                  {`${selectedSamples.length} masa türünü `} Aktar &nbsp;
                  <i className="fas fa-arrow-right" />
                </button>
              )}
              {loading && (
                <LoadingBox inline={true}>
                  <>&nbsp;Aktarılıyor</>
                </LoadingBox>
              )}
            </InputGroup>
          </div>
          <div className="sample-table-grid mt-3">
            {samples
              .filter((s) => s.status)
              .map((sample) => (
                <div
                  key={sample._id}
                  className={`sample-table-item ${
                    selectedSamples.includes(sample._id) ? "selected" : ""
                  } ${samplesAlreadyInUse.includes(sample._id) ? "faded" : ""}`}
                  onClick={() =>
                    !samplesAlreadyInUse.includes(sample._id) &&
                    handleSampleClick(sample._id)
                  }
                >
                  <img
                    src={sample.image || config.default_image}
                    alt={sample.name}
                    className="sample-table-image"
                  />
                  <div className="sample-table-name">{sample.name}</div>
                </div>
              ))}
          </div>
        </>
      }
    </div>
  );
}
